module.exports = __webpack_public_path__ + "img/goal-seventeen-en.fa21c62f.png";